import { SettingsSubsectionWrapper } from "@/pages/settings/components/setting-subsection-wrapper";
import { SettingsDataExportSection } from "@/pages/settings/components/settings-data-export-section";
import { SettingsSectionWrapper } from "@/pages/settings/components/settings-section-wrapper";
import { FC } from "react";

export const SettingsExportsPage: FC = () => {
  return (
    <SettingsSectionWrapper>
      <SettingsSubsectionWrapper title="Export notes and collections">
        <SettingsDataExportSection />
      </SettingsSubsectionWrapper>
    </SettingsSectionWrapper>
  );
};
